/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

//import { TweetyWidget } from '@vlinder-web/tweety-widget-react';
import React, { useEffect, useState } from 'react';
import { Acknowledgement } from '../Acknowledgement';
import { StateOSD } from '@vlinder-web/state-osd-v2-widget-react';
import Button from 'react-bootstrap/Button';
import { TweetyWidget } from '@/widgets/tweety-widget-react-main';
import { ItemSpecVenusWidget } from '@/widgets/item-spec-venus-widget-react';
import { ChannelPage } from '@/widgets/channel-page-widget-react';
import * as S from './styles';
import { RightContainer } from '../RightContainer';
import { getWidgetData } from '../RenewMarriageExemption/MarriageExemptionWidgetData';
import { USER_LEVEL } from '@/config/userManagement.config';
import { vappContainer } from '@/application';
import { ApplicationFormPageService } from '../../services';
import { Loader } from '@/components';
import toast from 'react-hot-toast';
import { FontSlider } from '../FontSlider';

const getSrv = () => {
  return vappContainer.get<ApplicationFormPageService>(
    ApplicationFormPageService.displayName
  );
};

interface ICsmeFormData {
  fields: any[];
  layout: any[];
  dynamicLayout?: any[];
  previewLabel?: string;
  csmeSubLabel1?: string;
  csmeSubLabel2?: string;
  progressBarSteps?: string[];
  validatorConfig?: any;

  successIcon?: string;
  errorIcon?: string;

  userFormFields: any[];
  userFormLayout: any[];
  userFormTitle: string;
}

export const RenewMarriageExemptionComp = ({
  marriageExemFormData,
  acknowledgement,
  onAcknowledgement,
  onGoBack,
  onCloseClick,
  marriageLabel,
  onNewCsmeNext,
  spinner,
  loading,
  _initialData,
  onDraftSave,
  currentStep,
  draftData,
  whoami,
  onFormSubmit,
  stepChange,
  csmePreviewSubLabel1,
  employeeAppliesApplicant,
  proceedInvite,
  setProceedToInvite,
  csmePreviewSubLabel2,
  csmeAppPageState,
  onPayClick,
  setEmployeeApplies,
  onUserDetailsSubmit,
  rightBlockContent,
  _changeTouchStatus,
  _changeCurrStep,
  touchedStatus,
  changeStepHasError,
  applicationNo,
  rendersave,
  fontScale,
  updateFontScale,
  citydata
}: {
  rightBlockContent?: any;
  marriageLabel: string;
  rendersave?: boolean;
  whoami?: string;
  currentStep?: number;
  marriageExemFormData: ICsmeFormData;
  fontScale: number;
  updateFontScale?(font: number): void;

  acknowledgement: any;
  onAcknowledgement?(data: any, type: string): void;
  onGoBack?(): void;
  applicationNo?: string;

  stepChange?(step: number, existingFormData: any): void;
  onCloseClick(): void;
  onNewCsmeNext?(formData: any): void;
  spinner?: any;
  loading?: any;
  touchedStatus?: any;
  _initialData?: any;
  onFormSubmit?(formData: any): void;
  setEmployeeApplies?(val: any): void;
  setProceedToInvite?(val: any): void;
  onPayClick?(appNo: string): void;
  onDraftSave?(formData: any, type: string, implicitSave?: boolean): void;
  draftData?: any;
  employeeAppliesApplicant?: boolean;
  proceedInvite?: boolean;
  csmePreviewSubLabel1?: string;
  _changeTouchStatus?(val: any): void;
  _changeCurrStep?(val: any): void;
  csmePreviewSubLabel2?: string;
  csmeAppPageState?: any;
  changeStepHasError?(err: any): void;
  onUserDetailsSubmit?(formData: any): void;
  citydata?:any;
}) => {
  const {
    fields,
    layout,
    dynamicLayout,
    previewLabel,
    csmeSubLabel1,
    csmeSubLabel2,

    errorIcon,
    successIcon,

    userFormFields,
    userFormLayout,
    userFormTitle,
    validatorConfig,
  } = marriageExemFormData;
  console.log('entered csmeform', _initialData);
  // fields[tempData[tempKey]-1] || []
  const [formlayout, setFormLayout] = useState(fields[0] || []);
  const [stepHasError, setStepHasError] = useState<any>({});
  const [touched, setTouched] = useState<any>({});
  const [formFields, setFormFields] = useState([]);
  const [stateLayout, setStateLayout] = useState(layout);
  const [jamaicangender, setJamaicanGender] = useState<any>({});
  const [totalFields, setTotalFields] = useState([
    ...fields[0],
    ...fields[1],
    ...fields[2],
  ]);
  const [lookUpFields, setLookUpFields] = useState({});
  const [totalSteps, settotalSteps] = useState(
    whoami === 'prospective_employee' ? 1 : 2
  );
  useEffect(() => {
    settotalSteps(whoami === 'prospective_employee' ? 1 : 2);
  }, [whoami]);
  console.log('who->', whoami, totalSteps);
  const [activeStep, setActiveStep] = useState(
    currentStep ?? 0
    // totalStep+1
  );

  const [dynamicKey, setdynamicKey] = useState('first');
  const [tempKey, settempKey] = useState('');
  useEffect(() => {
    setActiveStep(currentStep ?? 0);
  }, [currentStep]);
  const tempData: any = {
    first: 1,
    second: 2,
    third: 3,
    fourth: 4,
  };
  useEffect(() => {
    setFormLayout(fields[tempData[tempKey] - 1]);
  }, [tempKey]);
  const [subStep, setSubStep] = useState(activeStep >= 2 ? 2 : 0);
  const [initialData, setinitialData] = useState(
    _initialData && Object.entries(_initialData)?.length > 0
      ? _initialData
      : draftData?.data ?? {}
  );
  const [key, setkey] = useState('');
  useEffect(() => {
    if (spinner?.show === false && spinner?.status === 'success') {
      console.log(`on acknowledgemnt`);
      setActiveStep(activeStep + 1);
    }
  }, [spinner]);

  // useEffect(() => {
  //   if (_initialData && Object.entries(_initialData)?.length > 0) {
  //     setinitialData(_initialData);
  //     setkey(key + 'hi');
  //   } else if (draftData?.data) {
  //     console.log('io-> ::', draftData?.data);
  //     setkey(key + 'hi->');
  //     setinitialData(draftData?.data);
  //   }
  // }, [draftData?.data, _initialData]);

  useEffect(() => {
    console.log('iuy->', activeStep);
    setFormFields(fields[activeStep >= 1 ? 0 : activeStep]);
    window.scrollTo(0, 0);
  }, [activeStep]);

  useEffect(()=>{
    setTimeout(()=>{
      setinitialData({...initialData,i:0})
    },2500)
  },[])
  const _getCityOptions = (data: any[]) => {
    let _options: any[] = [];
    data &&
      Array.isArray(data) &&
      data.length > 0 &&
      data.map((item: string, index: number) => {
        if (item) {
          _options.push({
            label: item,
            id: item,
          });
        }
      });

    return _options;
  };
  const getcity=(parish:any)=>{
    return {parish:parish,cities: _getCityOptions(citydata?.[parish])}
  }
  const _renderHeader = (isPreview: boolean) => {
    console.log(`Preview label bla:`, isPreview);
    return (
      <div className="mt-2">
        {isPreview && (
          <h3 className="text-uppercase text-center">{previewLabel}</h3>
        )}
        <h4 className="text-center">{marriageLabel}</h4>
        <h6 className="text-center">
          {isPreview
            ? subStep >= 1
              ? csmePreviewSubLabel2
              : csmePreviewSubLabel1
            : activeStep >= 1 && activeStep < 2
            ? csmeSubLabel2
            : csmeSubLabel1}
        </h6>
      </div>
    );
  };

  useEffect(() => {
    setdynamicKey('first');
  }, [activeStep]);
  console.log('iob->', initialData);

  const changeTouchStatus = (data: any, key: string) => {
    setTouched({ ...touched, [`${activeStep}-${dynamicKey}`]: true });

    console.log('pok->', tempKey, dynamicKey);
    settempKey(key);
  };

  useEffect(() => {
    if (touched[`${activeStep}-${dynamicKey}`]) {
      console.log('pok->', tempKey, dynamicKey);
      setdynamicKey(tempKey);
    }
  }, [touched]);
  useEffect(() => {
    console.log('cpcpcp-->', initialData);
    initialData['jamaicanparish'] &&
      tempKey == 'second' &&
      updateCityParish(
        'jamaicanparish',
        initialData['jamaicanparish'],
        totalFields
      );
    initialData['coupleParish'] &&
      tempKey == 'third' &&
      updateCityParish(
        'coupleParish',
        initialData['coupleParish'],
        totalFields
      );
  }, [tempKey]);
  console.log('iob->', activeStep, totalSteps, employeeAppliesApplicant);

  // const tempData: any = {
  //   first: 1,
  //   second: 2,
  //   third: 3,
  //   fourth: 4,
  // };
  console.log('uio->', initialData);

  const _checkLayout = (layoutData: any[], key: string, action: string) => {
    console.log(`updateInitialData : _checkLayout :`, key, layoutData);

    let _res: any[] = [];
    if (action === 'delete') {
      layoutData.length > 0 &&
        layoutData.map((item: any) => {
          if (item?.length > 0 && item[0] !== key) {
            _res.push(item);
          }
        });
    } else if (action === 'add') {
      let isExist: boolean = false;
      layoutData.length > 0 &&
        layoutData.map((item: any) => {
          if (item?.length > 0 && item[0] === key) {
            isExist = true;
          }
        });
      if (isExist) {
        _res = layoutData;
      } else {
        _res = layoutData;
        _res.push([key]);
      }
    }
    return _res;
  };

  console.log(`8-> :: #3 ;`, formFields);
  const updateCityParish = async (id: any, payload: any, formlayout: any) => {
    console.log(`updateInitialData :`, id, payload, formFields, stateLayout);
    const dynamicItems = [
      { id: 'maritalStatus', payload: 'married', newItem: 'marriage' },
      { id: 'maritalStatus', payload: 'divorced', newItem: 'divorce' },
    ];
    let _layout: any = stateLayout;
    let _fields: any = [];
    if (
      id === 'parish' ||
      id === 'selfParish' ||
      id === 'employedParish' ||
      id === 'jamaicanparish' ||
      id === 'coupleParish' ||
      payload?.id === 'qualification' ||
      id === 'jamaicanparish'
    ) {
      //onParishChange && onParishChange({ ...initialData, [id]: payload });
      const actualPayload = payload?.payload ?? payload;
      const _response = getcity(actualPayload);
      console.log(`response from parish ::`, _response);
      if (_response) {
        let _fields: any = formlayout.map((item: any, index: number) => {
          console.log('86->', payload, item, _response.cities);

          if (id === 'parish' && item?.compProps?.id === 'city') {
            return {
              ...item,
              compProps: {
                ...item?.compProps,
                options: _response?.cities,
              },
            };
          } else if (
            id === 'selfParish' &&
            item?.compProps?.id === 'selfCity'
          ) {
            return {
              ...item,
              compProps: {
                ...item?.compProps,
                options: _response?.cities,
              },
            };
          } else if (
            id === 'coupleParish' &&
            item?.compProps?.id === 'coupleCity'
          ) {
            return {
              ...item,
              compProps: {
                ...item?.compProps,
                options: _response?.cities,
              },
            };
          } else if (
            id === 'jamaicanparish' &&
            item?.compProps?.id === 'jamaicancity'
          ) {
            return {
              ...item,
              compProps: {
                ...item?.compProps,
                options: _response?.cities,
              },
            };
          }
          // } else if (
          //   id === 'employerParishDep' &&
          //   item?.compProps?.id === 'employerCityDep'
          // ) {
          //   return {
          //     ...item,
          //     compProps: {
          //       ...item?.compProps,
          //       options: _response?.cities,
          //     },
          //   };
          // }
          else {
            return {
              ...item,
            };
          }
        });

        setFormFields(_fields);
        setFormLayout(_fields);
        console.log(`8-> :: #3 ;`, _fields);
      }
    }

    setStateLayout(_layout);
    if (initialData?.[id] !== payload) {
      setinitialData({ ...initialData, [id]: payload });
    }
  };
  const updateInitialData = async (id: any, payload: any) => {
    console.log(`updateInitialData :`, id, payload, formFields, stateLayout);
    const dynamicItems = [
      { id: 'maritalStatus', payload: 'married', newItem: 'marriage' },
      { id: 'maritalStatus', payload: 'divorced', newItem: 'divorce' },
    ];
    let city:any = null;
    let _layout: any = stateLayout;
    let _fields: any = [];
    if (
      id === 'parish' ||
      id === 'selfParish' ||
      id === 'employedParish' ||
      id === 'jamaicanparish' ||
      id === 'coupleParish' ||
      payload?.id === 'qualification' ||
      id === 'jamaicanparish'
    ) {
      //onParishChange && onParishChange({ ...initialData, [id]: payload });
      const actualPayload = payload?.payload ?? payload;
      const _response = getcity(actualPayload);
      console.log(`response from parish ::`, _response);
      if (_response) {
        console.log(`8-> :: #3 ;`, formFields);

        let _fields: any = formlayout.map((item: any, index: number) => {
          console.log('86->', payload, item, _response.cities);
          if (
            payload?.id === 'qualification' &&
            payload?.subId === 'parish' &&
            item?.compProps?.id === 'qualification'
          ) {
            console.log('86->hi->', item);
            return {
              ...item,
              compProps: {
                ...item?.compProps,
                attributeForm: {
                  ...item?.compProps?.attributeForm,
                  fields: item?.compProps?.attributeForm?.fields?.map(
                    (_item: any) => {
                      if (_item?.compProps?.id === 'city') {
                        return {
                          ..._item,
                          compProps: {
                            ..._item?.compProps,
                            options: _response?.cities,
                          },
                        };
                      }
                      return { ..._item };
                    }
                  ),
                },
                // options: _response?.cities,
              },
            };
          }
          if (id === 'parish' && item?.compProps?.id === 'city') {
            city=item?.compProps?.id;
            return {
              ...item,
              compProps: {
                ...item?.compProps,
                options: _response?.cities,
              },
            };
          } else if (
            id === 'selfParish' &&
            item?.compProps?.id === 'selfCity'
          ) {
            city=item?.compProps?.id;
            return {
              ...item,
              compProps: {
                ...item?.compProps,
                options: _response?.cities,
              },
            };
          } else if (
            id === 'coupleParish' &&
            item?.compProps?.id === 'coupleCity'
          ) {
            city=item?.compProps?.id;
            return {
              ...item,
              compProps: {
                ...item?.compProps,
                options: _response?.cities,
              },
            };
          } else if (
            id === 'jamaicanparish' &&
            item?.compProps?.id === 'jamaicancity'
          ) {
            city=item?.compProps?.id;
            return {
              ...item,
              compProps: {
                ...item?.compProps,
                options: _response?.cities,
              },
            };
          }
          // } else if (
          //   id === 'employerParishDep' &&
          //   item?.compProps?.id === 'employerCityDep'
          // ) {
          //   return {
          //     ...item,
          //     compProps: {
          //       ...item?.compProps,
          //       options: _response?.cities,
          //     },
          //   };
          // }
          else {
            return {
              ...item,
            };
          }
        });

        setFormFields(_fields);
        setFormLayout(_fields);
        console.log(`8-> :: #3 ;`, _fields);
      }
    }
    dynamicItems?.map((item) => {
      if (id === item?.id && payload !== item?.payload) {
        _layout =
          _layout &&
          Array.isArray(_layout) &&
          _layout.length > 0 &&
          _layout.map((_item: any, index: number) => {
            return {
              ..._item,
              third: {
                ..._item?.third,
                data: _checkLayout(_item?.third?.data, item?.newItem, 'delete'),
              },
            };
          });
      } else if (id === item?.id && payload === item?.payload) {
        _layout =
          _layout &&
          Array.isArray(_layout) &&
          _layout.length > 0 &&
          _layout.map((_item: any, index: number) => {
            return {
              ..._item,
              third: {
                ..._item?.third,
                data: _checkLayout(_item?.third?.data, item?.newItem, 'add'),
              },
            };
          });
      }
    });

    setStateLayout(_layout);
    if (initialData?.[id] !== payload) {
      setinitialData(city?{...initialData, [id]: payload, [city]: null}:{ ...initialData, [id]: payload });
    }
  };

  const _renderRightContainer = () => {
    return (
      <RightContainer rightBlockContent={rightBlockContent?.userInviteInfo} />
    );
  };

  const _renderBody = () => {
    console.log('8->', activeStep, totalSteps);

    if (activeStep === totalSteps) {
      return (
        <>
          {_renderHeader(true)}

          {/* @ts-ignore */}
          <ItemSpecVenusWidget
            {...getWidgetData(fields, initialData)}
            onListClick={(item: any) => console.log(`item clicked`, item)}
            onPageChange={(event: any) => console.log(`page change`, event)}
            onSubmit={() => {
              onAcknowledgement &&
                onAcknowledgement(initialData, 'RENEW_MARRIAGE_EXEMPTION');
            }}
            onActionClick={(key, listId) =>
              console.log(`on action click`, key, listId)
            }
            whoAmI={whoami}
            // onItemClick={(itemId: string) => window.alert(itemId)}
          />
        </>
      );
    }
    if (activeStep === totalSteps + 1) {
      return (
        <Acknowledgement
          {...acknowledgement}
          onPayClick={onPayClick}
          applicationNo={applicationNo}
          submitBtnText={acknowledgement?.submitBtnText ?? ''}
        />
      );
    }
    if (activeStep < totalSteps) {
      console.log('ho->', touched, stepHasError);

      const profileData = {
        isLargeTitle: true,
        navItems: Object.entries(
          layout[activeStep >= 1 ? activeStep - 1 : activeStep]
        )?.map((_item: any) => {
          return {
            key: _item[0],
            // title: `${stepHasError[`${activeStep}-${_item[0]}`]} ${_item[1]?.label}`,
            title: (
              <>
                {stepHasError[`${activeStep}-${_item[0]}`] === true && (
                  /* @ts-ignore */
                  <S.Img src={errorIcon} fontScale={fontScale} />
                )}
                {(stepHasError[`${activeStep}-${_item[0]}`] === false ||
                  (stepHasError[`${activeStep}-${_item[0]}`] === undefined &&
                    touched[`${activeStep}-${_item[0]}`])) && (
                  /* @ts-ignore */
                  <S.Img src={successIcon} fontScale={fontScale} />
                )}
                {_item[1]?.label}
              </>
            ),
            link: `/${_item[0]}`,
            type: 'navbar',
          };
        }),
      };
      console.log(
        `updateInitialData formFields: `,
        formFields,
        '\nstateLayout : ',
        stateLayout
      );
      console.log(
        'kj1->',
        stateLayout,
        stateLayout[activeStep >= 1 ? activeStep - 1 : activeStep]?.[dynamicKey]
          ?.data
      );
      return (
        <>
          {_renderHeader(false)}
          <FontSlider fontScale={fontScale} updateFontScale={updateFontScale} />

          <div style={{ justifyContent: 'center', display: 'flex' }}>
            <div style={{ width: '80%' }}>
              {/* @ts-ignore */}
              <ChannelPage
                {...profileData}
                activeKey={dynamicKey}
                isNoProfileExist={true}
                fontScale={fontScale}
                onNavItemClick={(key: string) => {
                  changeTouchStatus(initialData, key);
                }}
              />
              <TweetyWidget
                labelColor={'#104382'}
                fields={formlayout || formFields}
                fontScale={fontScale}
                key={`${
                  activeStep >= 1 ? activeStep - 1 : activeStep
                }-${dynamicKey}`}
                touchedStatus={!!touched[`${activeStep}-${dynamicKey}`]}
                onUpdateDynamicLayData={(data: any) =>
                  setinitialData({ ...initialData, ...data })
                }
                allTouched={touched}
                onErrorFree={() => {
                  if (
                    stepHasError[`${activeStep}-${dynamicKey}`] ||
                    stepHasError[`${activeStep}-${dynamicKey}`] === undefined
                  ) {
                    setStepHasError({
                      ...stepHasError,
                      [`${activeStep}-${dynamicKey}`]: false,
                    });
                  }
                }}
                onHandleError={(val) => {
                  console.log('ki->');
                  setStepHasError({
                    ...stepHasError,
                    [`${activeStep}-${dynamicKey}`]: val,
                  });
                }}
                initialData={{
                  ...initialData,
                }}
                lookUpFields={lookUpFields}
                updateLookUpFields={(data: any) => setLookUpFields(data)}
                layout={
                  stateLayout &&
                  stateLayout[activeStep >= 1 ? activeStep - 1 : activeStep]?.[
                    dynamicKey
                  ]?.data
                }
                dynamicLayout={dynamicLayout}
                // onChange={(payload) =>console.log('po->',payload)}
                onChange={(id, payload) => updateInitialData(id, payload)}
                validatorConfig={validatorConfig}
                onFormSubmit={(payload: any) => {
                  console.log('tempkkkkk', tempKey);
                  if (
                    initialData['jamaicanSex'] === initialData['gender'] &&
                    (tempKey === 'second' || tempKey === 'third')
                  ) {
                    toast.error(
                      `Both jamaican and expatriate cannot be ${
                        initialData['gender'] || initialData['jamaicanSex']
                      }`
                    );
                    window.scroll(0, 0);
                    return;
                  }
                  const formData = { ...initialData, ...payload };
                  setinitialData({ ...formData });
                  onDraftSave &&
                    onDraftSave(formData, 'RENEW_MARRIAGE_EXEMPTION', true);
                  console.log(`testing bla ::`, activeStep, totalSteps);
                  if (
                    Object.entries(
                      layout[activeStep >= 1 ? activeStep - 1 : activeStep]
                    )?.length === tempData[dynamicKey]
                  ) {
                    console.log(touched, 'ho->');
                    if (activeStep === totalSteps - 1) {
                      const allTouched = Object.entries(touched)?.filter(
                        (item) => !!item[1]
                      );
                      const allErrors = Object.entries(stepHasError)?.filter(
                        (item) => item[1]
                      );
                      let newTouched: any = {};
                      const total = Object.entries(
                        layout[activeStep >= 1 ? activeStep - 1 : activeStep]
                      )?.length;
                      console.log(
                        'ho->so',
                        allTouched,
                        allErrors,
                        allTouched.length,
                        total,
                        total - (touched[dynamicKey] ? 0 : 1)
                      );
                      if (
                        allErrors?.length === 0 &&
                        allTouched.length ===
                          total -
                            (touched[`${activeStep}-${dynamicKey}`] ? 0 : 1)
                      ) {
                        Object.entries(
                          layout[activeStep >= 1 ? activeStep - 1 : activeStep]
                        )?.forEach((item, key) => {
                          newTouched[`${activeStep}-${item[0]}`] = true;
                        });
                        _changeTouchStatus && _changeTouchStatus(newTouched);
                        setTouched({ ...newTouched });
                        settempKey('first');
                        changeStepHasError &&
                          changeStepHasError({
                            ...stepHasError,
                            [`${activeStep}-${dynamicKey}`]: false,
                          });
                        onFormSubmit && onFormSubmit({ ...formData });
                        stepChange &&
                          stepChange(activeStep + 1, { ...formData });
                        setActiveStep((activeStep) => activeStep + 1);
                      } else {
                        console.log('ho->');
                        let newTouched: any = {};
                        let err: any = {};
                        Object.entries(
                          layout[activeStep >= 1 ? activeStep - 1 : activeStep]
                        )?.forEach((item, key) => {
                          newTouched[`${activeStep}-${item[0]}`] = true;
                          if (!touched[`${activeStep}-${item[0]}`]) {
                            if (
                              key ===
                              Object.entries(
                                layout[
                                  activeStep >= 1 ? activeStep - 1 : activeStep
                                ]
                              )?.length -
                                1
                            ) {
                              err[`${activeStep}-${item[0]}`] = false;
                            } else {
                              err[`${activeStep}-${item[0]}`] = true;
                            }
                          }
                        });
                        setTouched(newTouched);
                        // console.log('ho->',stepHasError,err,{...stepHasError,...err});
                        setStepHasError({ ...stepHasError, ...err });
                        settempKey('first');
                        window.scrollTo(0, 0);
                      }
                      if (
                        activeStep == 3 &&
                        dynamicKey == 'third' &&
                        tempKey == 'third'
                      ) {
                        setActiveStep(4);
                        _changeCurrStep && _changeCurrStep(4);
                        // setCurrentStep(currentStep+1);
                        settempKey((tempKey) => tempKey + 1);
                      }
                    } else {
                      if (
                        activeStep == 3 &&
                        dynamicKey == 'third' &&
                        tempKey == 'third'
                      ) {
                        setActiveStep(4);
                        _changeCurrStep && _changeCurrStep(4);
                        settempKey((tempKey) => tempKey + 1);
                      } else setActiveStep((activeStep) => activeStep + 1);
                      stepChange && stepChange(activeStep + 1, { ...formData });
                      console.log('ho->');
                    }
                    //onNewWorkPermitNext && onNewWorkPermitNext(payload);
                  } else {
                    const ans = Object.entries(
                      layout[activeStep >= 1 ? activeStep - 1 : activeStep]
                    )?.map((_item) => _item?.[0]);
                    const key = ans.indexOf(dynamicKey);
                    const temp = Object.entries(
                      layout[activeStep >= 1 ? activeStep - 1 : activeStep]
                    )?.[key + 1]?.[0];
                    setStepHasError({
                      ...stepHasError,
                      [`${activeStep}-${dynamicKey}`]: false,
                    });
                    changeTouchStatus(initialData, temp);
                    console.log('ho->');
                    window.scroll(0, 0);
                  }
                }}
                submitButtonLabel={'Next'}
                renderSaveButton={rendersave ? false : true}
                onDraftSave={(data) =>
                  onDraftSave && onDraftSave(data, 'RENEW_MARRIAGE_EXEMPTION')
                }
              />
            </div>
          </div>
        </>
      );
    }
  };
  if (spinner?.show) {
    return <Loader {...loading} />;
  }
  return <>{_renderBody()}</>;
};

RenewMarriageExemptionComp.defaultProps = {
  loading: {
    image: '',
    titleNormalText: 'Submitting application',
    titleBoldText: '...',
    description: 'This might take few seconds, Please wait !',
  },
  csmePreviewSubLabel1: 'Confirm  Details',
  csmePreviewSubLabel2: 'Confirm  Details',
};
